import Vue from 'vue'
import VueRouter from 'vue-router'

import Base from '../pages/Index'
import Login from '../pages/Login'
import PageNotFound from '../pages/404'

const fb = require('../firebaseConfig.js')

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    component: Login
  },
  {
    path: '/',
    component: Base,
    children: [
      {
        path: 'home',
        component: () => import('../pages/Home')
      },
      {
        path: 'home/:userKey',
        component: () => import('../pages/Home'),
        props: true
      },
      {
        path: 'activity',
        component: () => import('../pages/ActivityLog')
      },
      {
        path: 'meets',
        component: () => import('../pages/GoogleMeets')
      },
      {
        path: 'staff',
        component: () => import('../pages/Staff')
      },
      {
        path: 'students/new',
        component: () => import('../pages/NewStudentAccounts')
      },
      {
        path: 'class/:uid',
        component: () => import('../pages/Class'),
        props: true
      },
      {
        path: 'classes',
        redirect: '/classes/me'
      },
      {
        path: 'students',
        component: () => import('../pages/Students'),
      },
      {
        path: 'gsuite/students',
        component: () => import('../pages/GsuiteStudentAccounts')
      },
      {
        path: 'classes/me',
        component: () => import('../pages/Classes'),
        props: { userKey: 'me', requiresAdmin: false }
      },
      {
        path: 'classes/all',
        component: () => import('../pages/Classes'),
        props: { userKey: 'all', requiresAdmin: true }
      },
      {
        path: 'skedula',
        component: () => import('../pages/SkedulaSync'),
        props: { requiresAdmin: true }
      },
    ]
  },
  {
    path: '/404',
    component: PageNotFound
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

fb.auth.onAuthStateChanged(function (user) {
  if (!user) {
    console.log(router)
    if( router.currentRoute.path !== '/login') {
      router.push('/login')
    }
  }
})

/***
 check for logged in user
 check route requirements
***/
router.beforeEach((to, from, next) => {
  console.log(to.path)
  if (to.path === '/') {
    router.push('/home')
  }
  if (to.path === '/login' || to.path === '/404') {
    next()
  } else {
    fb.session.ready.then(function (user) {
      if (user.role === 'DISABLED') {
        router.push({ path: '/login', query: { 'disabled': true } })
      } else if (to.meta.requiresAdmin && !user.isAdmin) {
        router.push('/404')
      } else {
        next()
      }
    })
  }
})

export default router
